import { EditSubaccountRequest } from 'vopay';
import { useApi } from '#shared/providers/Api';

// Ported from client-dashboard's useEditSubAccount (ID-13193), already Direct Pattern — only the api source
// changed, to the host-injected api via useApi(). A pure mutation — nothing stored, no fetching flag (the
// consuming component raises the blocking loader; loading-conventions).
export default function useEditSubAccount() {
  const api = useApi();

  async function editSubAccount(request: EditSubaccountRequest) {
    try {
      const res = await api.editSubaccount(request);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return { editSubAccount };
}
